// extracted by mini-css-extract-plugin
export default {"wrapper":"PreferencesPane_wrapper__OLqz6","tgConnectedButton":"PreferencesPane_tgConnectedButton__MqXi-"};